<nav class="navbar navbar-expand-lg nav-crev" [class.nav-scroll]="isSticky">
    <div class="container">
        <a class="navbar-brand icon-img-100" [routerLink] = "'/'">
            <img [src]="logo" alt="Logo" class="logo">
        </a>
        <button class="navbar-toggler ms-auto" type="button" (click)="isCollapsed = !isCollapsed" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <span class="icon-bar"><i class="icofont icofont-navigation-menu"></i></span>
        </button>
        <div class="collapse navbar-collapse" [ngClass]="{'collapse': isCollapsed, 'navbar-collapse': true}" id="navbarNavAltMarkup">
            <ul class="navbar-nav navbar-center xs-mt-20">
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('home')">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('features')">Features</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('products')">Products</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('offers')">Offers</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('subscribe')">Subscribe</a>
                </li>
            </ul>
            <div class="nav-button ms-auto xs-ml-0 xs-mt-20"><ul class="nav navbar-nav navbar-right"><li><button type="button" class="btn btn-lg btn-gradient-primary btn-circle">Try it Free</button></li></ul></div>
        </div>
        
    </div>
</nav>

<section class="pt-0 pb-0" id="home">
    <div class="slider-bg ecommerce-slider">
        <ul class="slides ecommerce-slides">
            <li>
                <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStore">
                        <div class="slide-img" style="background-image: url('{{slide.image}}')">
                            <div class="hero-text-wrap">
                                <div class="hero-text white-color">
                                    <div class="container text-left">
                                        <h1 class="title raleway-font">{{slide.introtext}}</h1>
                                        <h2 class="white-color font-700">{{slide.title}}</h2>
                                        <h3 class="sub-title font-100 raleway-font">{{slide.subtitle}}</h3>
                                        <a [routerLink]="'/about'" [ngClass]="slide.btnSlide"><span>{{slide.btnText}} <i class="icofont icofont-arrow-right"></i></span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </li>
        </ul>
    </div>
</section>

<section class="white-bg xs-pb-100" id="features">
    <div class="becki-collection-type-1">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-sm-6 col-xs-12 banner-left">
              <div class="row">
                  <div class="col-xs-12 col-md-6 col-sm-6 shop-banner" *ngFor="let item of features;">
                      <div class="becki-collection">
                          <a [ngClass]="item.url">
                            <img src="assets/images/shop/{{item.img}}" alt="becki-shop-banner"/>
                            <span class="becki-collection-btn">{{item.title}}</span>
                           </a>
                      </div>
                  </div>
              </div>
            </div>
    
            <div class="col-md-6 col-sm-6 col-xs-12 banner-right">
              <div class="shop-banner">
                  <div class="becki-collection">
                      <a href="#.">
                           <img src="assets/images/shop/banner-01.jpg" alt="becki-shop-banner"/>
                           <span class="becki-collection-btn">Woman Accessories</span>
                       </a>
                  </div>
              </div>
            </div>
    
          </div>
        </div>
    
    </div>
</section>

<section class="parallax-bg fixed-bg" style="background-image: url('assets/images/background/parallax-bg-4.jpg')">
    <div class="gradient-overlay-bg-six"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center parallax-content height-400px">
                <div class="center-layout">
                    <div class="v-align-middle">
                        <h1 class="font-400 white-color raleway-font xs-font-40px">Step into style and express yourself <br>with the latest fashion trends at our boutique!</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="dark-bg" id="products">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h1 class="raleway-font yellow-color mt-30 font-50px font-300 text-uppercase">Shop Features Products</h1>
                </div>
            </div>
        </div>

        <div class="row mt-50">
            <div class="col-md-3 col-sm-6 col-xs-12" *ngFor="let item of shopItem;">
                <div class="product-item becki-products">
                    <div class="product-image becki-product-thumbnail">
                        <a [ngClass]="item.url">
                            <img class="img-responsive" src="assets/images/shop/{{item.img}}" alt="becki-product"/>
                        </a>
                           <div class="product-action">
                               <button class="btn-shopping btn-light btn-md btn-default btn" type="button" value="Add to Cart">
                                   <i class="icofont icofont-cart"></i> <span>Add to Cart</span>
                               </button>
                           </div>
                           <div class="becki-product-actions">
                               <div class="product-addto-links">
                                   <a class="act-btn" data-label="Wishlist" href="#." data-toggle="tooltip" data-placement="left">
                                    <i class="icofont icofont-heart-alt"></i>
                                    <span class="visually-hidden">Wishlist</span>
                                </a>
                               </div>
                               <div class="quickview-btn hidden-sm hidden-xs">
                                   <a href="#." data-label="Quickview" class="act-btn" data-toggle="tooltip" data-placement="left">
                                       <i class="icofont icofont-plus"></i>
                                       <span class="visually-hidden">Quickview</span>
                                   </a>
                               </div>
                           </div>
                           <div class="wrap-label">
                            <span *ngFor="let label of item.labels" class="label-product" [ngClass]="{
                                'new-label': label === 'new',
                                'hot-label': label === 'hot',
                                'sale-label': label === '-50%'}">
                                {{ label }}
                              </span>
                           </div>
                    </div>
                    <div class="becki-product-content">
                        <h4><a href="#." class="becki-product-title" title="Product Title">{{item.title}}</a></h4>
                        <div class="product-price becki-product-price">
                            <span [ngClass]="item.priceClass">${{item.priceTxtNew}}</span>
                            <span [ngClass]="item.priceClassOld">${{item.priceTxtOld}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>

<section class="white-bg" id="offers">
    <div class="tr-collection-type-1">
      <div class="container">
          <div class="row">
            <div class="col-md-6 col-sm-6 col-xs-12 shop-banner" *ngFor="let banner of banners">
                  <div class="tr-collection">
                      <a href="#.">
                          <img src="assets/images/shop/{{banner.img}}" alt="banner"/>
                          <div class="tr-collection-content">
                              <h3>{{banner.offText}} <br> {{banner.title}}</h3>
                              <span class="btn btn-dark-outline btn-default btn-md">shop now</span>
                          </div>
                      </a>
                </div>
              </div>
          </div>
      </div>
    </div>
</section>

<section class="pt-80 pb-80 default-bg" id="subscribe">
    <div class="container">
        <div class="row">
            <div class="col-sm-7 section-heading white-color">
              <h3 class="font-600 mt-0">Sign up for newsletters</h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus sed fermentum nibh, vel aliquet massa. Etiam in magna id risus lacinia luctus eget eu est.</p>
                <div class="tr-form-subscribe mt-30">
                  <form class="signup-form remove-margin" method="post">
                      <div class="input-group password-input-group">
                          <input type="email" name="EMAIL" id="Email" class="md-input" value="" placeholder="Your Mail Address">
                          <span class="input-group-btn">
                            <button type="submit" class="newsletter-submit btn btn-dark btn-md btn-square" name="subscribe" id="Subscribe">
                              <span>sign up now</span>
                            </button>
                          </span>
                      </div>
                  </form>
                 </div>
          </div>
        </div>
    </div>
</section>